export const CLIENT_STATUS_META = {
  pending: { label: 'Awaiting response', className: 'bg-amber-50 text-amber-700 ring-amber-100' },
  accepted: { label: 'Accepted', className: 'bg-emerald-50 text-emerald-700 ring-emerald-100' },
  in_progress: { label: 'In progress', className: 'bg-blue-50 text-blue-700 ring-blue-100' },
  completed: { label: 'Completed', className: 'bg-emerald-50 text-emerald-700 ring-emerald-100' },
  cancelled: { label: 'Cancelled', className: 'bg-red-50 text-red-700 ring-red-100' },
  auto_cancelled: { label: 'Auto-cancelled', className: 'bg-red-50 text-red-700 ring-red-100' },
  lapsed: { label: 'No response', className: 'bg-amber-50 text-amber-700 ring-amber-100' },
  declined: { label: 'Declined', className: 'bg-slate-100 text-slate-600 ring-slate-200' },
};

export const getClientStatusMeta = (status) => CLIENT_STATUS_META[status] || CLIENT_STATUS_META.pending;

export const formatClientDate = (date) =>
  date ? new Date(date).toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' }) : '—';

export const formatClientMoney = (value) => `$${Number(value || 0).toFixed(2)}`;

export const activeClientStatuses = new Set(['pending', 'accepted', 'in_progress', 'lapsed', 'declined']);
